/**
 * Convert an object of query parameters to a query string
 *
 * @param obj - The object containing query parameters
 * @returns {string} The query string with leading '?' if params exist, empty string otherwise
 * @example { foo: 'bar', baz: 'qux' } returns '?foo=bar&baz=qux'
 */
export default function stringifyQueryParams(obj: Record<string, boolean | string>): string {
  const str: Array<string> = [];

  for (const p in obj) {
    if (obj.hasOwnProperty(p) && (obj[p] || obj[p] === false)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }

  if (str.length > 0) {
    return '?' + str.join('&');
  } else {
    return '';
  }
}
